export default [
    'china', 'japon', 'taiwan', 'miranda', 'india', 'alemania', 'italia', 'europa', 'eslovenia',
    'francia', 'korea', 'mexico', 'colombia', 'turquia', 'argentina', 'usa',
    'españa', 'brasil', 'israel', 'india', 'tailandia', 'malasia', 'chile', 'indonesia', 'rumania', 'ecuador',
    // Nuevos sugeridos
    'canada', 'reino unido', 'polonia', 'chequia', 'hungria', 'eslovaquia',
    'paises bajos', 'suecia', 'suiza', 'austria', 'portugal', 'belgica',
    'finlandia', 'noruega', 'australia', 'nueva zelanda', 'sudafrica',
    'arabia saudita', 'emiratos arabes unidos', 'singapur', 'vietnam', 'filipinas',
    'hong kong', 'peru', 'bolivia', 'uruguay', 'panama', 'costa rica', 'guatemala',
    'pakistan', 'bangladesh', 'kazajistan', 'ucrania', 'kuwait', 'qatar'
].sort().map(item => item.toUpperCase())